import React, { useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import { Card, Input, Switch, Button, message } from 'antd';
import { messageAllUsers, messageAllStaff, messageAllStudents, messageAllSchoolUsers, messageAllSchoolStaff, messageAllSchoolStudents, clearMessage } from '../../../_actions/user_actions';
import dayjs from 'dayjs';

function MessagePage(props) {
  const dispatch = useDispatch();
  const [textMessage, setTextMessage] = useState('');
  const [studentsEnabled, setStudentsEnabled] = useState(false);
  const [staffEnabled, setStaffEnabled] = useState(false);
  //target group is the last item in the path
  const targetGroup = props?.location?.pathname?.split('/').pop() ?? "loading";

  useEffect(() => {
    if (!props.user.message) return;
    if (props.user.message === "Message Sent") {
      message.success("Message Sent")
      props.history.push("/sysadmin/schools")
    }
    else {
        message.error(props.user.message)
    }
    dispatch(clearMessage())
  }, [props.user.message, dispatch, props.history])

  const handleSend = () => {
    if (targetGroup === "all") {
        if (studentsEnabled && staffEnabled) {
          //send to all at all schools
          dispatch(messageAllUsers({ message: dayjs().format('MM-DD-YY HH:mm') + ": " + textMessage }))
        }
        else if (studentsEnabled) {
          //send to students at all schools
          dispatch(messageAllStudents({ message: dayjs().format('MM-DD-YY HH:mm') + ": " + textMessage }))
        }
        else if (staffEnabled) {
          //send to staff at all schools
          dispatch(messageAllStaff({ message: dayjs().format('MM-DD-YY HH:mm') + ": " + textMessage }))
        }
        else {
          message.error("Please select a group to send to")
          return
        }
    }
    else {
        if (studentsEnabled && staffEnabled) {
          //send to all at target school
          dispatch(messageAllSchoolUsers({ school_id: targetGroup, message: dayjs().format('MM-DD-YY HH:mm') + ": " + textMessage }))
        }
        else if (studentsEnabled) {
          //send to students at target school
          dispatch(messageAllSchoolStudents({ school_id: targetGroup, message: dayjs().format('MM-DD-YY HH:mm') + ": " + textMessage }))
        }
        else if (staffEnabled) {
          //send to staff at target school
          dispatch(messageAllSchoolStaff({ school_id: targetGroup, message: dayjs().format('MM-DD-YY HH:mm') + ": " + textMessage }))
        }
        else {
          message.error("Please select a group to send to")
          return
        }
    }
  };

  return (
    <div style={{ maxWidth: 500, margin: '0 auto', padding: 16 }}>
      <Card title="Send Message">
        <Input.TextArea
          rows={5}
          placeholder="Type your message here..."
          value={textMessage}
          onChange={(e) => setTextMessage(e.target.value)}
          style={{ marginBottom: 16 }}
        />

        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>Send to Students</span>
            <Switch checked={studentsEnabled} onChange={setStudentsEnabled} />
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <span>Send to Staff</span>
            <Switch checked={staffEnabled} onChange={setStaffEnabled} />
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div>Target Group</div>
          <Input value={targetGroup} readOnly />
        </div>

        <Button type="primary" block onClick={handleSend}>
          Send
        </Button>
      </Card>
    </div>
  );
}

function mapStateToProps(state) {
  return { data: state };
}

export default withRouter(connect(mapStateToProps)(MessagePage));

